import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

interface IProps {
    active?: boolean
}

export const ArticleNavigationItem = styled.button<IProps>`
    background: none;
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;

    &:not(&:first-child) {
        margin-left: 20px;

        ${cssMediaQueryBreakpoints.medium} {
            margin-left: 14px;
        }
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        height: 4px;
        width: 100%;
        background: ${p => p.theme.playColor};
        display: ${p => (p.active ? 'block' : 'none')};
    }
`
